<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <TitleComponent title="2. Tus entradas" subtitle="Completa la información necesaria para cada uno de los abonos seleccionados"></TitleComponent>
            </div>
            <div class="col-12 mt-3" v-if="datos_compradores.length > 0">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="select_all" id="select_all">
                    <label class="custom-control-label" for="select_all">Seleccionar todas las entradas</label>
                </div>
            </div>
            <div class="col-12 mt-3">
                <div class="form-group">
                    <label for="concepto">Concepto</label>
                    <small>Este texto irá incluido en la entrada, máximo 15 caracteres</small>
                    <input maxlength="15" type="text" name="concepto" class="form-control" id="concepto" placeholder="Concepto" v-model="concepto">
                </div>
            </div>
            <div class="col-12 mt-3">
                <FormInput label="CP/ZIP CODE" minlength="5" maxlength="10" name="ccp" id="cp" v-model="cp" />
            </div>
            <div class="col-12" v-if="datos_compradores.length > 0">
                <div class="row">
                    <template v-for="(entrada, index) in datos_compradores">
                        <div class="col-4" :key="index">
                            <DatosEntradasComponent :entrada="entrada" :generos="generos" :index="index" :key="reloadComponent" :solicitar_datos="solicitar_datos" v-on:actualizado="actualizar(index)"></DatosEntradasComponent>
                        </div>
                    </template>                
                </div>
            </div>
            <div class="col-12" v-if="entradas_seleccionadas">
                <DatosEntradaSinZonaComponent :entradas="entradas_seleccionadas" :siguiente="false" loading="false"></DatosEntradaSinZonaComponent>
            </div>
            <div class="col-12 mb-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="enviar_email" id="enviar_email">
                    <label class="custom-control-label" for="enviar_email">Enviar por email</label>
                </div>
            </div>
            <div class="col-12 mb-3" v-if="enviar_email">
                <FormInput label="Email" name="email" id="email" rules="required|email" v-model="email" />
            </div>
            <div class="col-12 mb-3">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="enviar_whatsapp" id="enviar_whatsapp">
                    <label class="custom-control-label" for="enviar_whatsapp">Enviar por WhatsApp</label>
                </div>
            </div>
            <div class="col-12 mb-3" v-if="enviar_whatsapp">
                <FormInput label="Nombre" name="nombre" id="nombre" rules="required" v-model="nombre" />
                <FormInput label="Telefono" name="telefono" id="telefono" rules="required" v-model="telefono" />
            </div>
            <div class="col-12" v-if="false">
                <div class="form-group">
                    <label for="metodo_pago">Descuento</label>
                    <select v-model="descuento" class="form-control" id="descuento">
                        <option value="0">Sín descuento</option>
                        <template v-for="(descuento, index) in configuracion.descuentos_disponibles">
                            <option :key="index" :value="descuento">{{ descuento }}%</option>
                        </template>                            
                    </select>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="metodo_pago">Método de pago / Tipo de Impresión</label>
                    <ValidationProvider name="telefono" rules="required" v-slot="{ errors }">
                        <select v-model="metodo_pago" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="metodo_pago">
                            <template v-for="(metodo, index) in metodos_pago">
                                <option :key="index" :value="metodo">{{ metodo.texto }}</option>
                            </template>                            
                        </select>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12">
                <Button v-if="continuar" type="submit" class="btn-block">CONTINUAR COMPRA</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import DatosEntradasComponent from '@/components/backend/stepper/components/DatosEntradasComponent';
    import DatosEntradaSinZonaComponent from '@/components/backend/stepper/components/DatosEntradaSinZonaComponent';
    import Generos from "@/mixins/Generos";

    export default {
        props: ['datos_compradores', 'entradas_seleccionadas', 'solicitar_datos'],
        mixins: [Generos],
        data() {
            return {
                concepto: null,
                cp: null,
                select_all: null,
                enviar_email: null,
                enviar_whatsapp: null,
                email: null,
                nombre: null,
                telefono: null,
                metodos_pago : [
                    { valor : 1, texto : 'METÁLICO' },
                    { valor : 3, texto : 'DATÁFONO' },
                    { valor : 6, texto : 'INVITACIÓN' },
                    { valor : 10, texto : 'INVITACIÓN INFANTIL' },
                    { valor : 7, texto : 'Día de Abonado (0€)' },
                    { valor : 8, texto : 'TRANSFERENCIA' },
                    { valor : 9, texto : 'DOMICILIADO' }
                ],
                metodo_pago: null,
                descuento: 0,
                es_invitacion: false,
                reloadComponent: 0
            }
        },
        created() {
            this.getGeneros();
            if (this.permisos['eventos.no_permitir_invitaciones']) {
                this.metodos_pago.splice(2, 1);
            }
            for(var i in this.datos_compradores) {
                this.datos_compradores[i].precio = 0;
                this.datos_compradores[i].descuento = 0;
            }
        },
        watch: {
            descuento() {
                if(this.datos_compradores.length > 0) {
                    for(var i in this.datos_compradores) {
                        this.datos_compradores[i].descuento = this.descuento;
                    }
                } else {
                    for(var x in this.entradas_seleccionadas) {
                        this.entradas_seleccionadas[x].descuento = this.descuento;
                    }
                }
            }
        },
        computed: {
            continuar() {
                this.datos_compradores.forEach(entrada => {
                    if(entrada.precio == null) {
                        return false;
                    }                       
                });

                return true;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            }
        },
        methods: {
            goTo(paso) {
                var datos = {
                    cp: this.cp,
                    concepto: this.concepto,
                    enviar_email: this.enviar_email,
                    enviar_whatsapp: this.enviar_whatsapp,
                    email: this.email,
                    nombre: this.nombre,
                    telefono: this.telefono,
                    metodo_pago: this.metodo_pago
                };
                this.$emit('goTo', paso, datos, this.enviar_email, this.enviar_whatsapp);
            },
            actualizar (index) {
                this.es_invitacion = this.datos_compradores[index].precio.precio == 0;
                
                if(this.es_invitacion) {
                    this.metodo_pago = this.metodos_pago[2];
                }
                
                if(this.select_all) {
                    var genero_id = this.datos_compradores[index].genero_id;

                    var precio = this.datos_compradores[index].precio;

                    var descuento = this.datos_compradores[index].descuento;

                    var nombre = this.datos_compradores[index].nombre;

                    var apellidos = this.datos_compradores[index].apellidos;

                    for(var i in this.datos_compradores) {
                        this.loading = i;
                        this.datos_compradores[i].genero_id = genero_id;
                        this.datos_compradores[i].precio = precio;
                        this.datos_compradores[i].descuento = descuento;
                        this.datos_compradores[i].nombre = nombre;
                        this.datos_compradores[i].apellidos = apellidos;
                    }
                }

                this.reloadComponent += 1;
            },
            async submit() {
                
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.goTo(4);
                } else {
                    this.$nextTick(function() {
                        this.$scrollTo('.is-invalid', 100)
                    });
                }
            }
        },
        components: {
            TitleComponent, DatosEntradasComponent, DatosEntradaSinZonaComponent
        }
    }
</script>

<style>

</style>
